import { type SxProps } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const GeneralErrorTitleStyles: SxProps = {
  '& svg': {
    '& path': {
      fill: themeColors.red,
    },
    alignSelf: 'center',
    fontSize: '28px',
    mx: 1,
  },
  display: 'flex',
  justifyContent: 'center',
};
